/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HomeNowResponse } from '../models/HomeNowResponse';
import { SportEnum } from '../models/SportEnum';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HomeService {
    /**
     * @deprecated
     * Get Home Now
     * Get the current home data.
     * @param sports
     * @param areaOfInterestId
     * @returns HomeNowResponse Successful Response
     * @throws ApiError
     */
    public static getHomeNowHomeNowGet(
        sports: SportEnum,
        areaOfInterestId: number,
    ): CancelablePromise<HomeNowResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/home/now',
            query: {
                'sports': sports,
                'area_of_interest_id': areaOfInterestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
